<template>
  <b-container>
    <slot></slot>
  </b-container>
</template>

<script>
export default {};
</script>